<div
  class="tw-flex tw-flex-col tw-gap-5 sm:tw-gap-[18px] tw-w-full tw-bg-color-surface-elevated tw-rounded-[20px] sm:tw-rounded-[22px_22px_0_0] tw-shadow-elevation-modal-drop sm:tw-shadow-[0px_-6px_30px_0px_rgba(13,18,31,0.3)] tw-pt-7 sm:tw-pt-[24px] tw-px-7 sm:tw-px-[20px] tw-pb-[26px] sm:tw-pb-[calc(28px+env(safe-area-inset-bottom,0px))]"
  role="dialog"
  aria-modal="true"
  aria-labelledby="grocery-help-title"
>
  <div class="tw-flex tw-flex-col tw-gap-1.5">
    <h2
      id="grocery-help-title"
      class="tw-m-0 tw-text-[21px] sm:tw-text-[19px] tw-font-semibold tw-text-color-text-default"
    >
      {{ "groceryHelpDialogTitle" | i18n }}
    </h2>
    <!-- Desktop subtitle: searching/comparing/refreshing. -->
    <p class="tw-m-0 tw-text-[13.5px] tw-font-medium tw-text-color-text-tertiary sm:tw-hidden">
      {{ "groceryHelpDialogSubtitle" | i18n }}
    </p>
    <!-- Mobile subtitle: "it's a checklist, not a selection list". -->
    <p
      class="tw-m-0 tw-hidden sm:tw-block tw-text-[13px] tw-font-medium tw-text-color-text-tertiary"
    >
      {{ "groceryHelpDialogSubtitleMobile" | i18n }}
    </p>
  </div>

  <!-- Desktop tips: search / best price / missing items / refresh. -->
  <div class="tw-flex tw-flex-col tw-gap-5 tw-w-full sm:tw-hidden">
    @for (tip of tips; track tip.titleKey) {
      <div class="tw-flex tw-gap-3.5 tw-items-start tw-w-full">
        <div class="tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-w-[30px] tw-h-[30px]">
          <icon [name]="tip.icon" [size]="4" currentColor="color-icon-action"></icon>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-0.5 tw-flex-1 tw-min-w-0">
          <p class="tw-m-0 tw-text-sm tw-font-semibold tw-text-color-text-default">
            {{ tip.titleKey | i18n }}
          </p>
          <p class="tw-m-0 tw-text-[12.5px] tw-font-medium tw-text-color-text-tertiary">
            {{ tip.descriptionKey | i18n }}
          </p>
        </div>
      </div>
    }
  </div>

  <!-- Mobile tips: tick off / tap a row for actions / archive keeps it / prices have an age.
       tw-contents keeps each row a direct child of the sheet's own gap-[18px] column
       (matching the design's flat spacing) while still toggling as one unit. -->
  <div class="tw-hidden sm:tw-contents">
    @for (tip of mobileTips; track tip.titleKey) {
      <div class="tw-flex tw-gap-3.5 tw-items-start tw-w-full">
        <div class="tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-size-[30px]">
          @if (tip.kind === "checkbox") {
            <div
              class="tw-flex tw-items-center tw-justify-center tw-size-[22px] tw-rounded-full tw-bg-color-action-primary"
            >
              <icon name="check-only" [size]="3" currentColor="color-text-on-action"></icon>
            </div>
          } @else {
            <icon [name]="tip.icon" [size]="4" currentColor="color-icon-action"></icon>
          }
        </div>
        <div class="tw-flex tw-flex-col tw-gap-0.5 tw-flex-1 tw-min-w-0">
          <p class="tw-m-0 tw-text-sm tw-font-semibold tw-text-color-text-default">
            {{ tip.titleKey | i18n }}
          </p>
          <p class="tw-m-0 tw-text-[12.5px] tw-font-medium tw-text-color-text-tertiary">
            {{ tip.descriptionKey | i18n }}
          </p>
        </div>
      </div>
    }
  </div>

  <button
    type="button"
    class="tw-w-full tw-h-10 tw-rounded-2xl tw-bg-color-action-primary tw-text-color-text-on-action tw-text-sm tw-font-semibold tw-shadow-elevation-card tw-border-none tw-cursor-pointer hover:tw-bg-color-action-primary-hover"
    (click)="dismiss()"
  >
    {{ "gotIt" | i18n }}
  </button>
</div>
